<template>
  <div class="deviceAss_cla">
    <div class="black_panel_cla">
      <div class="header-button-bar">
        <el-button style="float: right"
                   @click.stop="showBindDia"
                   type="primary"
                   size="small"
                   :disabled="orgId === ''">{{ this.$t('device.assignDevice') }}</el-button>

        <el-button style="float: right; margin-right: 10px"
                   @click.stop="ubBindEven"
                   type="primary"
                   size="small"
                   :disabled="deviceList.length === 0">{{ this.$t('device.unBindBtn') }}</el-button>
      </div>
      <el-table @selection-change="changeUnBindSelection"
                :data="deviceList">
        <el-table-column type="selection"
                         width="65"></el-table-column>
        <el-table-column prop="devSn"
                         :label="this.$t('device.sn')"></el-table-column>
        <el-table-column prop="devAlias"
                         :label="this.$t('device.alias')"></el-table-column>
        <el-table-column prop="devStatus"
                         :label="this.$t('common.status')">
          <template slot-scope="scope">
            <deviceStatus :status="scope.row.devStatus===0 ? 1 : 0"></deviceStatus>
          </template>
        </el-table-column>

        <el-table-column :label="this.$t('common.action')">
          <template slot-scope="scope">
            <el-tag class="action_btn"
                    @click="viewDevice(scope.row)"
                    type="success">view</el-tag>
            <el-tag class="action_btn"
                    @click="deleteDevice(scope.row)"
                    type="info">
              <i class="el-icon-delete"></i>
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :append-to-body="true"
               :title="this.$t('device.selectDeivces')"
               :visible.sync="bindDialogTableVisible">
      <el-table height="400"
                :data="unBindList"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="55"></el-table-column>
        <el-table-column prop="devSn"
                         :label="this.$t('device.sn')"></el-table-column>
        <el-table-column prop="devAlias"
                         :label="this.$t('device.alias')"></el-table-column>
        <el-table-column prop="devStatus"
                         :label="this.$t('common.status')">
          <template slot-scope="scope">
            <deviceStatus :status="scope.row.devStatus ===0? 1: 0"></deviceStatus>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click.stop="cancelBind">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary"
                   @click="submitBind">{{
          $t('common.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getOrgDevices,
  orgUnbindDevice,
  getUnBindDeviceList,
  orgBindDevices
} from '@/services/deviceApi.js'
export default {
  data () {
    return {
      bindDialogTableVisible: false,
      orgId: '',
      deviceList: [],
      unBindList: [],
      multipleSelection: [], // 绑定的选中元素
      multipleUnbind: []
    }
  },
  props: {
    currentOrg: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted () {
    this.getOrgDeviceList()
  },
  watch: {
    'currentOrg.id': {
      handler: function (val, oVal) {
        if (val) {
          this.orgId = val
          this.getOrgDeviceList()
        }
      },
      deep: true
    }
  },
  methods: {
    ubBindEven () {
      if (this.multipleUnbind.length < 1) {
        this.errorMessage(this.$t('device.selectUnBindDevice'))
        return false
      } else {
        let deviceSnIds = this.multipleUnbind.map((item) => {
          return item.devSn
        })
        let params = {
          deviceSn: deviceSnIds,
          organizationId: this.orgId
        }
        this.submitUbBind(params)
      }
    },
    changeUnBindSelection (val) {
      this.multipleUnbind = val
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    cancelBind () {
      this.bindDialogTableVisible = false
    },
    showBindDia () {
      if (!this.orgId) {
        this.errorMessage(this.$t('device.selectDept'))
        return false
      }
      this.getUnbindList()
      this.bindDialogTableVisible = true
    },
    submitBind () {
      if (this.multipleSelection.length > 0) {
        let ids = this.multipleSelection.map((item) => {
          return item.devSn
        })
        let params = {
          deviceSn: ids,
          organizationId: this.orgId
        }
        orgBindDevices(params)
          .then((data) => {
            if (data.code === '00000000') {
              this.bindDialogTableVisible = false
              this.getOrgDeviceList()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch((e) => {
            this.errorMessage()
          })
      } else {
        this.errorMessage(this.$t('common.selectRecod'))
      }
    },
    getOrgDeviceList () {
      // 获取组织架构已经绑定的设备
      let params = {
        organizationId: this.orgId
      }
      getOrgDevices(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.deviceList = data.payload.results.devices
          } else {
            this.deviceList = []
            this.errorMessage(data.message)
          }
        })
        .catch((e) => {
          this.errorMessage()
        })
    },
    submitUbBind (params) {
      let _this = this
      this.$confirm(
        this.$t('device.unBindDept'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          orgUnbindDevice(params)
            .then((data) => {
              if (data.code === '00000000') {
                _this.getOrgDeviceList()
              } else {
                _this.errorMessage(data.message)
              }
            })
            .catch((data) => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },

    deleteDevice (row) {
      let params = {
        deviceSn: [row.devSn],
        organizationId: this.orgId
      }
      this.submitUbBind(params)
    },

    getUnbindList () {
      let params = {
        organizationId: this.orgId
      }
      getUnBindDeviceList(params)
        .then((data) => {
          if (data.code === '00000000') {
            this.unBindList = data.payload.results.devices
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch((e) => {
          this.errorMessage()
        })
    },
    viewDevice (row) {
      this.$router.push({ name: 'deviceList', query: { sn: row.devSn } })
    }
  }
}
</script>

<style scoped lang="less">
.deviceAss_cla {
  .action_btn {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/orgStructure/deviceAssignment.vue